import { Result, Button } from 'antd';
import { navigate } from "@reach/router"


export function ThankYou(props) {

    return (<Result
        status="success"
        title={props.msg}
        // subTitle="Ozveme se s během 5 dní s detaily na zadaný email."
        extra={[
            <Button onClick={() => { navigate(`https://cestasey.cz/potkej-se-s-nami`) }}>
                Naše další akce
            </Button>,
            <Button onClick={() => { navigate(`https://cestasey.cz/volne-pozice`) }}> Volné pozice</Button >,
            <Button onClick={() => { navigate(`mailto:hr.cz@cz.ey.com?subject=${props.eventName}`) }}> Kontaktuj nás</Button >
        ]}
    />)
}
export function EventPassed(props) {

    return (<Result
        status="success"
        title="Na tuto akci už se nelze přihlásit, ale rádi se s tebou potkáme při jiné příležitosti."
        // subTitle="Ozveme se s během 5 dní s detaily na zadaný email."
        extra={[
            <Button onClick={() => { navigate(`https://cestasey.cz/potkej-se-s-nami`) }}>
                Naše další akce
            </Button>,
            <Button onClick={() => { navigate(`https://cestasey.cz/volne-pozice`) }}>Volné pozice</Button >,
            <Button onClick={() => { navigate(`mailto:hr.cz@cz.ey.com?subject=${props.eventName}`) }}> Kontaktuj nás</Button >
        ]}
    />)
}